/* unplugin-vue-components disabled */import script from "./MctView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MctView.vue?vue&type=script&lang=ts&setup=true"

import "./MctView.vue?vue&type=style&index=0&id=312deeb2&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-312deeb2"]])

export default __exports__